import { FC } from "react";
import OrderDetailsToolsTranslations from "../../../../../languages/types/order/details/order-details-tools.translation";
import { OrderDetailsToolsPropsStatus } from "../types/order-details-tools";
import OrderDetailsToolButtonComponent from "../../common/tool-button/order-details-tool-button.component";
import { faX } from "@fortawesome/free-solid-svg-icons";
import { OrderCargoOrderChangeApprovalStatusParamsApprovalStatus } from "../../../../../common/services/order/cargo-order/change-approval-status/order-cargo-order-change-approval-status-params";
import orderService from "../../../../../common/services/order/order.service";
import useAbort from "../../../../../common/hooks/use-abort";
import notificationService from "../../../../../common/utils/notification/notification.service";

type OrderDetailsRejectComponentProps = {
  tools: OrderDetailsToolsTranslations;
  status: OrderDetailsToolsPropsStatus | null;
  orderId: string;
  onOrderReject: () => void;
  hasAccess: boolean;
};

const OrderDetailsRejectComponent: FC<OrderDetailsRejectComponentProps> = ({
  orderId,
  status,
  tools,
  onOrderReject,
  hasAccess,
}) => {
  const changeApprovalStatusAbort = useAbort();

  if (!hasAccess) return null;
  if (!status) return null;

  const isDisabled = [
    OrderDetailsToolsPropsStatus.CANDIDATURE,
    OrderDetailsToolsPropsStatus.IN_PROGRESS,
    OrderDetailsToolsPropsStatus.PLANNED,
    OrderDetailsToolsPropsStatus.REJECTED,
  ].includes(status);

  return (
    <OrderDetailsToolButtonComponent
      icon={faX}
      type="danger"
      title={tools.rejectButtonTitle}
      onClick={() => {
        orderService
          .changeApprovalStatus(
            {
              orderUuid: orderId,
              status:
                OrderCargoOrderChangeApprovalStatusParamsApprovalStatus.REJECTED,
            },
            changeApprovalStatusAbort.signal,
          )
          .then(() => {
            onOrderReject();
            notificationService.success(tools.rejectSuccessNotification);
          })
          .catch(() => {
            notificationService.error(tools.rejectFailureNotification);
          });
      }}
      isDisabled={isDisabled}
    />
  );
};

export default OrderDetailsRejectComponent;
